/** Script census of a text sample (ENGINE-SPEC §2.12 "script ranges"). */

const SCRIPT_TESTS: Array<[string, RegExp]> = [
	['Han', /\p{Script=Han}/u],
	['Hangul', /\p{Script=Hangul}/u],
	['Kana', /[\p{Script=Hiragana}\p{Script=Katakana}]/u],
	['Cyrillic', /\p{Script=Cyrillic}/u],
	['Arabic', /\p{Script=Arabic}/u],
	['Hebrew', /\p{Script=Hebrew}/u],
	['Devanagari', /\p{Script=Devanagari}/u],
	['Thai', /\p{Script=Thai}/u],
	['Greek', /\p{Script=Greek}/u],
];
const RE_LETTER = /\p{L}/u;
const RE_LATIN = /\p{Script=Latin}/u;

export interface ScriptCensus {
	/** Number of letters counted. */
	letters: number;
	/** Share of letters in Latin script (0 when there are no letters). */
	latinShare: number;
	/** Dominant script name, or 'none'. */
	dominant: string;
	counts: Record<string, number>;
}

export function scriptCensus(sample: string): ScriptCensus {
	const counts: Record<string, number> = {};
	let letters = 0;
	let latin = 0;
	const n = sample.length;
	for (let i = 0; i < n; i++) {
		const c = sample.charCodeAt(i);
		if (c < 128) {
			if ((c >= 65 && c <= 90) || (c >= 97 && c <= 122)) {
				letters++;
				latin++;
			}
			continue;
		}
		let s = sample[i] as string;
		if (c >= 0xd800 && c <= 0xdbff && i + 1 < n) {
			s += sample[i + 1] as string;
			i++;
		}
		if (!RE_LETTER.test(s)) continue;
		letters++;
		if (RE_LATIN.test(s)) {
			latin++;
			continue;
		}
		let name = 'Other';
		for (const [nm, re] of SCRIPT_TESTS) {
			if (re.test(s)) {
				name = nm;
				break;
			}
		}
		counts[name] = (counts[name] ?? 0) + 1;
	}
	counts.Latin = latin;
	let dominant = 'none';
	let best = 0;
	for (const [k, v] of Object.entries(counts)) {
		if (v > best) {
			best = v;
			dominant = k;
		}
	}
	return { letters, latinShare: letters === 0 ? 0 : latin / letters, dominant, counts };
}
